<div class="are-you-sure-content-container">
  <div
    id="bulk-retry-confirm-title"
    class="mat-headline-4 are-you-sure-text-container"
  >
    {{ 'SERVICE_PLAN_RECONCILIATION.BULK_RETRY_CONFIRM_TITLE' | translate }}
  </div>
  <div class="are-you-sure-text-container">
    {{
      'SERVICE_PLAN_RECONCILIATION.BULK_RETRY_CONFIRM_MESSAGE'
        | translate: { count: data.count }
    }}
  </div>
  <div class="are-you-sure-text-container">
    {{ 'SERVICE_PLAN_RECONCILIATION.BULK_RETRY_CONFIRM_NOTE_WARNING' | translate }}
  </div>
  <div class="are-you-sure-button">
    <app-action-button
      kind="filled"
      color="primary"
      size="extra-wide"
      (onClick)="close(true)"
      >{{
        'SERVICE_PLAN_RECONCILIATION.BULK_RETRY_CONFIRM_YES' | translate
      }}</app-action-button
    >
  </div>
  <div class="are-you-sure-button">
    <app-action-button
      kind="outline"
      color="primary"
      size="extra-wide"
      (onClick)="close(false)"
      >{{
        'SERVICE_PLAN_RECONCILIATION.BULK_RETRY_CONFIRM_CANCEL' | translate
      }}</app-action-button
    >
  </div>
</div>
